import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MoveExtensionsAndDeleteLocationMutationVariables = Types.Exact<{
  sourceLocationId: Types.Scalars['Int']['input'];
  destinationLocationId: Types.Scalars['Int']['input'];
}>;


export type MoveExtensionsAndDeleteLocationMutation = { __typename?: 'Mutation', moveUsers?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null, deleteLocation?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string } | null> | null };

export type DeleteLocationMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string } | null> | null };

export type LocationsToRearrangeWithExtensionsQueryVariables = Types.Exact<{
  locationId: Types.Scalars['Int']['input'];
}>;


export type LocationsToRearrangeWithExtensionsQuery = { __typename?: 'Query', locationsToRearrange?: Array<{ __typename?: 'RearrangeLocation', id: number, name: string, pilotNumber: string } | null> | null, users?: { __typename?: 'UserList', totalCount?: number | null } | null };

export type AssignableExtensionsQueryVariables = Types.Exact<{
  locationId: Types.Scalars['Int']['input'];
}>;


export type AssignableExtensionsQuery = { __typename?: 'Query', assignableUsers?: Array<{ __typename?: 'AssignableUser', id: number, shortNumber: string } | null> | null };

export type AssignExtensionMutationVariables = Types.Exact<{
  locationId: Types.Scalars['Int']['input'];
  userId: Types.Scalars['Int']['input'];
}>;


export type AssignExtensionMutation = { __typename?: 'Mutation', assignUser?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string } | null> | null };

export type SaveLocationMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId: Types.Scalars['Int']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  callLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  bandwidthLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  description?: Types.InputMaybe<Types.Scalars['String']['input']>;
  ipAddress?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pilotNumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
  emergencyPrefix?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SaveLocationMutation = { __typename?: 'Mutation', saveLocation: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', context?: string | null, type: string, location: Array<string> }> | null } };

export type LocationListWithPilotNumberFragment = { __typename?: 'Location', name: string, description: string, pilotNumber: string, canBeDeleted?: boolean | null };

export const LocationListWithPilotNumberFragmentDoc = gql`
    fragment LocationListWithPilotNumber on Location {
  name
  description
  pilotNumber
  canBeDeleted
}
    `;
export const MoveExtensionsAndDeleteLocationDocument = gql`
    mutation MoveExtensionsAndDeleteLocation($sourceLocationId: Int!, $destinationLocationId: Int!) {
  moveUsers(
    sourceLocationId: $sourceLocationId
    destinationLocationId: $destinationLocationId
  ) {
    errors {
      location
      context
      type
    }
  }
  deleteLocation(id: $sourceLocationId) {
    location
    context
    type
  }
}
    `;
export type MoveExtensionsAndDeleteLocationMutationFn = Apollo.MutationFunction<MoveExtensionsAndDeleteLocationMutation, MoveExtensionsAndDeleteLocationMutationVariables>;

/**
 * __useMoveExtensionsAndDeleteLocationMutation__
 *
 * To run a mutation, you first call `useMoveExtensionsAndDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveExtensionsAndDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveExtensionsAndDeleteLocationMutation, { data, loading, error }] = useMoveExtensionsAndDeleteLocationMutation({
 *   variables: {
 *      sourceLocationId: // value for 'sourceLocationId'
 *      destinationLocationId: // value for 'destinationLocationId'
 *   },
 * });
 */
export function useMoveExtensionsAndDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<MoveExtensionsAndDeleteLocationMutation, MoveExtensionsAndDeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveExtensionsAndDeleteLocationMutation, MoveExtensionsAndDeleteLocationMutationVariables>(MoveExtensionsAndDeleteLocationDocument, options);
      }
export type MoveExtensionsAndDeleteLocationMutationHookResult = ReturnType<typeof useMoveExtensionsAndDeleteLocationMutation>;
export type MoveExtensionsAndDeleteLocationMutationResult = Apollo.MutationResult<MoveExtensionsAndDeleteLocationMutation>;
export type MoveExtensionsAndDeleteLocationMutationOptions = Apollo.BaseMutationOptions<MoveExtensionsAndDeleteLocationMutation, MoveExtensionsAndDeleteLocationMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($id: Int!) {
  deleteLocation(id: $id) {
    location
    context
    type
  }
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const LocationsToRearrangeWithExtensionsDocument = gql`
    query LocationsToRearrangeWithExtensions($locationId: Int!) {
  locationsToRearrange(locationId: $locationId) {
    id
    name
    pilotNumber
  }
  users(locationId: $locationId) {
    totalCount
  }
}
    `;

/**
 * __useLocationsToRearrangeWithExtensionsQuery__
 *
 * To run a query within a React component, call `useLocationsToRearrangeWithExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsToRearrangeWithExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsToRearrangeWithExtensionsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useLocationsToRearrangeWithExtensionsQuery(baseOptions: Apollo.QueryHookOptions<LocationsToRearrangeWithExtensionsQuery, LocationsToRearrangeWithExtensionsQueryVariables> & ({ variables: LocationsToRearrangeWithExtensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsToRearrangeWithExtensionsQuery, LocationsToRearrangeWithExtensionsQueryVariables>(LocationsToRearrangeWithExtensionsDocument, options);
      }
export function useLocationsToRearrangeWithExtensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsToRearrangeWithExtensionsQuery, LocationsToRearrangeWithExtensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsToRearrangeWithExtensionsQuery, LocationsToRearrangeWithExtensionsQueryVariables>(LocationsToRearrangeWithExtensionsDocument, options);
        }
export function useLocationsToRearrangeWithExtensionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationsToRearrangeWithExtensionsQuery, LocationsToRearrangeWithExtensionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationsToRearrangeWithExtensionsQuery, LocationsToRearrangeWithExtensionsQueryVariables>(LocationsToRearrangeWithExtensionsDocument, options);
        }
export type LocationsToRearrangeWithExtensionsQueryHookResult = ReturnType<typeof useLocationsToRearrangeWithExtensionsQuery>;
export type LocationsToRearrangeWithExtensionsLazyQueryHookResult = ReturnType<typeof useLocationsToRearrangeWithExtensionsLazyQuery>;
export type LocationsToRearrangeWithExtensionsSuspenseQueryHookResult = ReturnType<typeof useLocationsToRearrangeWithExtensionsSuspenseQuery>;
export type LocationsToRearrangeWithExtensionsQueryResult = Apollo.QueryResult<LocationsToRearrangeWithExtensionsQuery, LocationsToRearrangeWithExtensionsQueryVariables>;
export const AssignableExtensionsDocument = gql`
    query AssignableExtensions($locationId: Int!) {
  assignableUsers(locationId: $locationId) {
    id
    shortNumber
  }
}
    `;

/**
 * __useAssignableExtensionsQuery__
 *
 * To run a query within a React component, call `useAssignableExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignableExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignableExtensionsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useAssignableExtensionsQuery(baseOptions: Apollo.QueryHookOptions<AssignableExtensionsQuery, AssignableExtensionsQueryVariables> & ({ variables: AssignableExtensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignableExtensionsQuery, AssignableExtensionsQueryVariables>(AssignableExtensionsDocument, options);
      }
export function useAssignableExtensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignableExtensionsQuery, AssignableExtensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignableExtensionsQuery, AssignableExtensionsQueryVariables>(AssignableExtensionsDocument, options);
        }
export function useAssignableExtensionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssignableExtensionsQuery, AssignableExtensionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssignableExtensionsQuery, AssignableExtensionsQueryVariables>(AssignableExtensionsDocument, options);
        }
export type AssignableExtensionsQueryHookResult = ReturnType<typeof useAssignableExtensionsQuery>;
export type AssignableExtensionsLazyQueryHookResult = ReturnType<typeof useAssignableExtensionsLazyQuery>;
export type AssignableExtensionsSuspenseQueryHookResult = ReturnType<typeof useAssignableExtensionsSuspenseQuery>;
export type AssignableExtensionsQueryResult = Apollo.QueryResult<AssignableExtensionsQuery, AssignableExtensionsQueryVariables>;
export const AssignExtensionDocument = gql`
    mutation AssignExtension($locationId: Int!, $userId: Int!) {
  assignUser(locationId: $locationId, userId: $userId) {
    location
    context
    type
  }
}
    `;
export type AssignExtensionMutationFn = Apollo.MutationFunction<AssignExtensionMutation, AssignExtensionMutationVariables>;

/**
 * __useAssignExtensionMutation__
 *
 * To run a mutation, you first call `useAssignExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignExtensionMutation, { data, loading, error }] = useAssignExtensionMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignExtensionMutation(baseOptions?: Apollo.MutationHookOptions<AssignExtensionMutation, AssignExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignExtensionMutation, AssignExtensionMutationVariables>(AssignExtensionDocument, options);
      }
export type AssignExtensionMutationHookResult = ReturnType<typeof useAssignExtensionMutation>;
export type AssignExtensionMutationResult = Apollo.MutationResult<AssignExtensionMutation>;
export type AssignExtensionMutationOptions = Apollo.BaseMutationOptions<AssignExtensionMutation, AssignExtensionMutationVariables>;
export const SaveLocationDocument = gql`
    mutation SaveLocation($id: Int, $domainId: Int!, $name: String, $callLimit: Int, $bandwidthLimit: Int, $description: String, $ipAddress: String, $pilotNumber: String, $emergencyPrefix: String) {
  saveLocation(
    id: $id
    domainId: $domainId
    name: $name
    callLimit: $callLimit
    bandwidthLimit: $bandwidthLimit
    description: $description
    ipAddress: $ipAddress
    pilotNumber: $pilotNumber
    emergencyPrefix: $emergencyPrefix
  ) {
    id
    errors {
      context
      type
      location
    }
  }
}
    `;
export type SaveLocationMutationFn = Apollo.MutationFunction<SaveLocationMutation, SaveLocationMutationVariables>;

/**
 * __useSaveLocationMutation__
 *
 * To run a mutation, you first call `useSaveLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationMutation, { data, loading, error }] = useSaveLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      domainId: // value for 'domainId'
 *      name: // value for 'name'
 *      callLimit: // value for 'callLimit'
 *      bandwidthLimit: // value for 'bandwidthLimit'
 *      description: // value for 'description'
 *      ipAddress: // value for 'ipAddress'
 *      pilotNumber: // value for 'pilotNumber'
 *      emergencyPrefix: // value for 'emergencyPrefix'
 *   },
 * });
 */
export function useSaveLocationMutation(baseOptions?: Apollo.MutationHookOptions<SaveLocationMutation, SaveLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLocationMutation, SaveLocationMutationVariables>(SaveLocationDocument, options);
      }
export type SaveLocationMutationHookResult = ReturnType<typeof useSaveLocationMutation>;
export type SaveLocationMutationResult = Apollo.MutationResult<SaveLocationMutation>;
export type SaveLocationMutationOptions = Apollo.BaseMutationOptions<SaveLocationMutation, SaveLocationMutationVariables>;